<template>
  <page>
    <template slot="content">
    <help-content :title="'ベルトを交換したい'">
      <template slot="content">
        <div class="text">
          交換用ベルトは<a class="help-detail-link" href="https://h5.werunclub.net/user-bean/index.html#/bean/gifts/23">ホーム＞マイルを使う</a>にてお買い求めいただけます。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help35.vue